export default __webpack_public_path__ + "static/media/inActiveHeaderPhone.2de74864.svg";